import forOwn from 'lodash/forOwn';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IOrder, IOrderLine } from '@cakeiteasy/web-utils';
import { CART_LINE_TYPES, DELIVERY_ORDER_DELIVERY_TYPES } from '../../../cart';

@Component({
  standalone: false,
  selector: 'order-info-summary',
  styles: [`
      .summary-value-col {
          width: 110px;
          padding-left: 10px;
      }
  `],
  template: `
    <div class="d-flex justify-content-end text-end font-md text-danger"
         *ngIf="refund !== 0">
      <div [translate]="'receipt.refund'">
        Refund
      </div>
      <div class="summary-value-col">
        {{ refund | currencyFormat: currency }}
      </div>
    </div>

    <div class="d-flex justify-content-end text-end font-md"
         *ngFor="let vat of vats">
      <div>
        <span [translate]="'receipt.vat'"></span>&nbsp;
        ({{ vat.percent }} %)
      </div>
      <div class="summary-value-col">
        {{ vat.value | currencyFormat: currency }}
      </div>
    </div>

    <div class="d-flex justify-content-end text-end text-bold mt-1 font-md">
      <div [translate]="'receipt.totalPrice'">Total price</div>

      <div class="summary-value-col">
        {{ total | currencyFormat: currency }}
      </div>
    </div>
  `
})
export class OrderInfoSummaryComponent implements OnInit, OnChanges {
  @Input() order: IOrder;
  @Input() currency: string;
  @Input() isCustomerView: boolean;

  vats: any;
  refund = 0;
  total: number;

  ngOnChanges(changes: SimpleChanges) {
    this.total = this.calcTotal();
  }

  ngOnInit(): void {
    this.vats = this._getVatsAr(this.order.multiOrder.vats);
    this.refund = this._getRefund(this.order.orderLines);
  }

  private calcTotal(): number {
    const isOffer = !Boolean(this.order.number);
    const { deliveryOrder, multiOrder } = this.order;
    const deliveryType = deliveryOrder ? deliveryOrder.deliveryType : null;
    const { THIRD_PARTY } = DELIVERY_ORDER_DELIVERY_TYPES;

    if (isOffer && deliveryType === THIRD_PARTY) {
      return multiOrder.price + deliveryOrder.externalDeliveryFee;
    }

    if (this.isCustomerView) {
      return multiOrder.price;
    }

    const deliveryOrderPrice = deliveryOrder ? deliveryOrder.price : 0;
    return this.order.price + deliveryOrderPrice;
  }

  private _getVatsAr(vats: any) {
    const result = [];
    forOwn(vats, (value, key) => {
      result.push({ percent: key, value });
    });

    return result;
  }

  private _getRefund(orderLines: IOrderLine[]): number {
    return orderLines
      .filter((ol) => ol.type === CART_LINE_TYPES.REFUND)
      .reduce((result, ol) => result + ol.price, 0);
  }
}
